import type { HomeProject } from "./projects";

export function getProjectTypeTag(
	project: Pick<HomeProject, "type" | "categories">,
) {
	const [firstType] = resolveProjectTypes(project);

	if (!firstType) {
		return "PROJETO";
	}

	const normalizedType = normalizeValue(firstType);

	if (normalizedType.includes("aplicativo") || normalizedType.includes("app")) {
		return "APLICATIVO";
	}

	if (normalizedType.includes("sistema")) {
		return "SISTEMA";
	}

	if (normalizedType.includes("site")) {
		return "SITE";
	}

	return firstType.toUpperCase();
}

/**
 * Tipo do projeto para filtro e rótulo. Vem de `type` quando o Strapi tem o
 * campo preenchido; senão cai nas categorias relacionadas.
 */
export function resolveProjectTypes(
	project: Pick<HomeProject, "type" | "categories">,
) {
	const typedValues = project.type.filter(Boolean);

	if (typedValues.length > 0) {
		return typedValues;
	}

	return project.categories
		.map((category) => category.reduce ?? category.name)
		.filter(Boolean);
}

function normalizeValue(value: string) {
	return value
		.normalize("NFD")
		.replaceAll(/[\u0300-\u036f]/g, "")
		.trim()
		.toLowerCase();
}

/** Casa o projeto com um tipo da galeria ("Aplicativos", "Sistemas", "Sites"). */
export function projectMatchesType(project: HomeProject, type: string) {
	const normalizedType = normalizeValue(type);
	const projectTypes = resolveProjectTypes(project).map(normalizeValue);

	return projectTypes.some((projectType) => {
		if (normalizedType === "aplicativos") {
			return projectType.includes("aplicativo") || projectType.includes("app");
		}

		if (normalizedType === "sistemas") {
			return projectType.includes("sistema");
		}

		if (normalizedType === "sites") {
			return projectType.includes("site");
		}

		return projectType === normalizedType;
	});
}
